(() => {
  const pad = (value) => String(Math.max(0, value)).padStart(2, '0');

  const splitDuration = (milliseconds) => {
    const totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));
    return {
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60,
    };
  };

  const renderTimer = (timer, milliseconds) => {
    const values = splitDuration(milliseconds);
    timer.querySelectorAll('[data-unit]').forEach((node) => {
      const unit = node.dataset.unit;
      node.textContent = unit === 'days' ? String(values[unit]) : pad(values[unit]);
    });
  };

  const initCampaignCountdown = (section) => {
    const timer = section.querySelector('[data-dalji-campaign-countdown]');
    if (!timer) return;

    const start = new Date(timer.dataset.start).getTime();
    const end = new Date(timer.dataset.end).getTime();
    const blackDayStart = new Date(timer.dataset.blackDayStart).getTime();
    const blackDayEnd = new Date(timer.dataset.blackDayEnd).getTime();
    const label = section.querySelector('[data-dalji-campaign-label]');

    const tick = () => {
      const now = Date.now();
      let target = start;
      let state = 'before';

      if (now >= start && now <= end) {
        target = end;
        state = now >= blackDayStart && now <= blackDayEnd ? 'black-day' : 'live';
      } else if (now > end) {
        state = 'ended';
      }

      section.dataset.campaignState = state;
      if (label) {
        if (state === 'before') label.textContent = label.dataset.before;
        if (state === 'live') label.textContent = label.dataset.live;
        if (state === 'black-day') label.textContent = label.dataset.blackDay;
        if (state === 'ended') label.textContent = label.dataset.ended;
      }

      renderTimer(timer, state === 'ended' ? 0 : target - now);
    };

    tick();
    window.setInterval(tick, 1000);
  };

  const initFlashOffers = (section) => {
    const offers = [...section.querySelectorAll('[data-dalji-offer]')];
    const empty = section.querySelector('[data-dalji-flash-empty]');
    const stateLabel = section.querySelector('[data-dalji-flash-state]');
    if (!offers.length) {
      if (empty) empty.hidden = false;
      return;
    }

    const parsedOffers = offers
      .map((node) => ({
        node,
        start: new Date(node.dataset.start).getTime(),
        end: new Date(node.dataset.end).getTime(),
      }))
      .filter((offer) => Number.isFinite(offer.start) && Number.isFinite(offer.end))
      .sort((a, b) => a.start - b.start);

    let visibleOffer = null;

    const tick = () => {
      const now = Date.now();
      const active = parsedOffers.find((offer) => now >= offer.start && now < offer.end);
      const next = parsedOffers.find((offer) => offer.start > now);
      const selected = active || next || null;

      if (selected !== visibleOffer) {
        offers.forEach((offer) => { offer.hidden = true; });
        if (selected) selected.node.hidden = false;
        if (empty) empty.hidden = Boolean(selected);
        visibleOffer = selected;
      }

      if (!selected) {
        if (stateLabel) stateLabel.textContent = stateLabel.dataset.ended;
        return;
      }

      const isActive = selected === active;
      const target = isActive ? selected.end : selected.start;
      const timer = selected.node.querySelector('[data-dalji-offer-countdown]');
      const action = selected.node.querySelector('[data-dalji-offer-action]');
      const timingLabel = selected.node.querySelector('[data-dalji-offer-timing-label]');

      if (stateLabel) {
        stateLabel.textContent = isActive ? stateLabel.dataset.live : stateLabel.dataset.next;
      }
      if (timingLabel) {
        timingLabel.textContent = isActive ? timingLabel.dataset.live : timingLabel.dataset.next;
      }
      if (action) {
        action.hidden = !isActive;
      }
      if (timer) renderTimer(timer, target - now);
    };

    tick();
    window.setInterval(tick, 1000);
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-dalji-black-hero]:not([data-initialized])').forEach((section) => {
      section.dataset.initialized = 'true';
      initCampaignCountdown(section);
    });
    scope.querySelectorAll('[data-dalji-black-flash]:not([data-initialized])').forEach((section) => {
      section.dataset.initialized = 'true';
      initFlashOffers(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
